import React from "react";
import tutifyLogo from "../../assets/images/tutifyLogo.png";
import fbIcon from "../../assets/images/facebook (2).png";
import twitterIcon from "../../assets/images/twitter (1).png";
import instagramIcon from "../../assets/images/instagram (2).png";
import linkedInIcon from "../../assets/images/linkedin (1).png";
import locationIcon from "../../assets/images/location.png";
import callIcon from "../../assets/images/call.png";
import mailIcon from "../../assets/images/mail.png";
import { Link } from "react-router-dom";
import FooterLogo from "../footer-logo";
import {
  PaymentFailed_url,
  PaymentSuccess_url,
  Privacy_url,
  ReturnRefund_url,
  Terms_url,
} from "../../constants";
import { Grid } from "antd";
const Footer = () => {
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()
  const isLargeScreen = screens.xl;
  const isMed = screens.sm && screens.md && screens.lg;
  const isSmall = (screens.xs || screens.sm ) && !screens.md


  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const quickLinks = [
    {
      id: 1,
      name: "Home",
      url: "/",
    },
    {
      id: 2,
      name: "about",
      url: "/about",
    },
    // {
    //   id: 3,
    //   name: "blogs",
    //   url: "#BlogArticles",
    // },
    // {
    //   id: 4,
    //   name: "featured teacher",
    //   url: "#FeaturedTeachers",
    // },
    // {
    //   id: 5,
    //   name: "course offer",
    //   url: "#CourseOffered",
    // },
    {
      id: 6,
      name: "contact",
      url: "/contact",
    },
    {
      id: 7,
      name: "Privacy Policy",
      url: Privacy_url,
    },
    {
      id: 8,
      name: "Return and Refund Policy",
      url: ReturnRefund_url,
    },
    {
      id: 9,
      name: "Terms and Conditions",
      url: Terms_url,
    },
    // {
    //   id: 10,
    //   name: "Payment Failed",
    //   url: PaymentFailed_url,
    // },
    // {
    //   id: 11,
    //   name: "Payment Success",
    //   url: PaymentSuccess_url,
    // },
  ];
  const services = [
    {
      id: 1,
      name: "free learning",
      url: "/",
    },
    {
      id: 2,
      name: "scholerships",
      url: "/",
    },
    {
      id: 3,
      name: "community services",
      url: "/",
    },
    {
      id: 4,
      name: "become a teacher",
      url: "/",
    },
    {
      id: 5,
      name: "find a teacher",
      url: "/",
    },
  ];

  const handleScroll = (event, id) => {
    event.preventDefault();
    const targetElement = document.getElementById(id);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <footer
        className="text-light pt-5"
        style={{
          background: "#001529",
          // paddingLeft: "20px",
          // paddingRight: "20px",
          padding: isLargeScreen ? "0px 110px" : "0px 20px", // fallback padding
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="logo">
                <FooterLogo />
              </div>
              <p className="my-4 fs_14">
                At Tutify our mission is to create a community where students
                feel empowered to reach their full potential and teachers feel
                inspired to make a real difference.
              </p>

              {/* <div className="py-4">
                <Link to="/">
                  <img width={25} className="me-3" src={fbIcon} alt="fb icon" />
                </Link>
                <Link to="/">
                  <img
                    width={25}
                    className="me-3"
                    src={twitterIcon}
                    alt="twitter Icon"
                  />
                </Link>
                <Link to="/">
                  <img
                    width={25}
                    className="me-3"
                    src={instagramIcon}
                    alt="instagram icon"
                  />
                </Link>
                <Link to="/">
                  <img
                    width={25}
                    className="me-3"
                    src={linkedInIcon}
                    alt="linkedIn Icon"
                  />
                </Link>
              </div> */}
            </div>

            <div className="col-md-4 ps-lg-5">
              <h6 className="mb-4 pt-2 text_skyBluez text-uppercase">
                Quick Links
              </h6>
              <ul className="list-unstyled">
                {quickLinks.map((item) => (
                  <li key={item.id} className="my-1">
                    {item.url.startsWith("#") ? (
                      <a
                        href={item.url}
                        onClick={(e) =>
                          handleScroll(e, item.url.replace("#", ""))
                        }
                        className="text-decoration-none text-white fs_12 text-uppercase"
                      >
                        {item.name}
                      </a>
                    ) : (
                      <Link
                        to={item.url}
                        className="text-decoration-none text-white fs_12 text-uppercase"
                      >
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* <div className="col-md-3  ps-lg-5">
              <h6 className="mb-4 pt-2 text_skyBluez text-uppercase">
                Services
              </h6>
              <ul className="list-unstyled">
                {services?.map((item) => {
                  return (
                    <li key={item?.id} className="my-1">
                      <Link
                        className="text-decoration-none text-white fs_12 text-uppercase"
                        to={item?.url}
                      >
                        {item?.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div> */}

            <div className="col-md-4">
              <h6 className="mb-4 pt-2 text_skyBluez text-uppercase">
                Contact us
              </h6>
              <div className="pb-2">
                <img
                  width={10}
                  className="me-3"
                  src={locationIcon}
                  alt="location"
                />{" "}
                <a
                  className="fs_12 text-decoration-none text-white"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.google.com/maps/dir//192-P,+P.E.C.H.S+Block+2+Block+2+PECHS,+Karachi,+karachi,+Sindh+75400/@24.863706,66.9779971,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3eb33e9aef94d4df:0x8e243231cd14e116!2m2!1d67.0603986!2d24.8637286?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoJLDEwMjExMjMzSAFQAw%3D%3D"
                >
                  192-P, P.E.C.H.S Block 2, Karachi
                </a>
              </div>
              <div className="pb-2">
                <img width={10} className="me-3" src={callIcon} alt="call" />{" "}
                <a
                  className="fs_12 text-decoration-none text-white"
                  href="tel:92-309-0888439."
                  target="_blank"
                  rel="noreferrer"
                >
                  +92-309-0888439
                </a>
              </div>
              <div>
                <img width={10} className="me-3" src={mailIcon} alt="mail" />{" "}
                <a
                  href="mailto:info@example.com"
                  className="fs_12 text-decoration-none text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  info@tutifyonline.com
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-between">
          <p className="fs_12">
            Copyright &#169; tutify.online {currentYear} All Rights Reserved
          </p>
          <div className="">
            <Link
              to="/privacy"
              className="text-decoration-none text-white fs_12"
            >
              Privacy Policy
            </Link>
            {" | "}
            <Link to="/terms" className="text-decoration-none text-white fs_12">
              Terms of Services
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
